module.exports = {
  api_baseurl: process.env.REACT_APP_API_BASEURL,
  hostname: process.env.REACT_APP_NISROOM_HOSTNAME,
};
